<template>
	<teleport to="body">
		<div :id="POPUP_ROOT_ID" class="popup-root">
			<slot />
		</div>
	</teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { PopupSystem } from '../src';

export default defineComponent({
	setup() {
		return {
			POPUP_ROOT_ID: PopupSystem.systemId,
		};
	},
});
</script>

<style lang="scss">
.popup-root {
	max-width: 0;
	max-height: 0;
}
</style>
